import { ListItemButton, ListItemText } from '@mui/material';
import { TNotificationFieldsFragment } from 'generated/graphql';

interface INotificationActionItem {
  data: TNotificationFieldsFragment;
  onClick: () => void;
}

const NotificationActionItem = ({ onClick, data }: INotificationActionItem) => {
  return (
    <ListItemButton onClick={onClick} sx={{ alignItems: 'flex-start' }}>
      <ListItemText
        primary={data.title}
        secondary={data.description}
        primaryTypographyProps={{
          variant: 'textBase',
          sx: {
            fontWeight: data.read ? '100' : 'bold',
            color: 'primary.main',
          },
        }}
        secondaryTypographyProps={{
          variant: 'textBase',
          sx: { fontWeight: data.read ? '100' : 'bold', color: 'primary.dark' },
        }}
      />
    </ListItemButton>
  );
};

export default NotificationActionItem;
